import { render, staticRenderFns } from "./FootRouter.vue?vue&type=template&id=5ca3c9e0&"
import script from "./FootRouter.vue?vue&type=script&lang=js&"
export * from "./FootRouter.vue?vue&type=script&lang=js&"
import style0 from "./FootRouter.vue?vue&type=style&index=0&id=5ca3c9e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports